module.exports = __webpack_public_path__ + "static/media/LandingVideo.02bd1058.mp4";